import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gou",
  "use": "icon-gou-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-gou\">\n<path d=\"M190.6,32.6c4.6,4.6,4.6,12,0,16.6L68.9,170.9L9.7,111.7c-4.7-4.4-5-11.8-0.6-16.6c4.4-4.7,11.8-5,16.6-0.6\n\tc0.2,0.2,0.4,0.4,0.6,0.6l42.6,42.6L174,32.6C178.6,28,186,28,190.6,32.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol